<template>
  <div>
    <img
      v-if="language == 'it'"
      src="../../assets/italian.jpg"
      id="language_it"
    />
    <img
      v-if="language == 'en'"
      src="../../assets/english.png"
      id="language_en"
    />

    <select
      name="language-picker-select"
      id="language-picker-select"
      @change="switchLanguage(language)"
      v-model="language"
    >
      <option value="en">English</option>
      <option value="it" selected>Italiano</option>
    </select>
  </div>
</template>
<script>
import $ from "jquery";
import { getCookie } from "../../utils/cookie";
export default {
  name: "language-picker",
  data() {
    return {
      language: null
    };
  },
  mounted: function() {
    var self = this;
    let cookie_lang = getCookie("language");
    if (cookie_lang && ["it", "en"].includes(cookie_lang)) {
      self.switchLanguage(cookie_lang);
    } else {
      self.switchLanguage(
        (navigator.language || navigator.userLanguage).split("-")[0]
      );
    }
  },
  methods: {
    switchLanguage: function(lang) {
      var self = this;
      self.language = lang;
      document.cookie = "language=" + self.language;
      this.$i18n.locale = lang;
    }
  }
};
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */

.nav-style {
  height: 50px;
}

#language_it {
  height: 15px;
}

#language_en {
  height: 15px;
}

#language_ru {
  height: 15px;
}

#language-picker-select {
  height: 28px;
  width: 80px;
  color: #027953;
  padding-left: 5px;
  text-align: center;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/language-picker/LanguagePicker.vue